var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.948 5.628C2.948 3.624 4.55 2 6.527 2h10.947c1.977 0 3.579 1.624 3.579 3.628s-1.602 3.628-3.58 3.628H6.528c-1.977 0-3.58-1.624-3.58-3.628Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.5 7.895.201.489a3.579 3.579 0 0 0 3.304 2.232h3.758v.454c0 1.252 1.002 2.267 2.237 2.267 1.236 0 2.237-1.015 2.237-2.267v-.454h3.759c1.445 0 2.748-.88 3.303-2.232l.201-.489v9.977c0 2.004-1.602 3.628-3.579 3.628H6.08c-1.976 0-3.579-1.624-3.579-3.628V7.895Zm6.921 7.242c0-.5.4-.907.895-.907h3.368c.494 0 .895.406.895.907s-.4.907-.895.907h-.79v1.814h1.5a.9.9 0 0 1 .895.907.9.9 0 0 1-.894.907h-4.79a.9.9 0 0 1-.895-.907c0-.5.401-.907.895-.907h1.5v-1.814h-.79a.9.9 0 0 1-.894-.907Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.105 10.616v.454c0 .5.401.907.895.907a.9.9 0 0 0 .895-.907v-.454h-1.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.46a89c7d9392b37a2a2321f4021c9aa2.svg";
export { ForwardRef as ReactComponent };